module.exports = __webpack_public_path__ + "img/full_zit.a5900a3d.png";